<script setup>
import { ref, toRefs } from 'vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'
import { SendOutlined } from '@ant-design/icons-vue'
import BaseRadio from '@/src/vueComponent/BaseRadio.vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

const props = defineProps({
  token: {
    type: String
  },
  supplierInfo: {
    type: Object,
    default: () => {
      return {
        id: null,
        name: '',
        englist_name: '',
        ubn: '',
        category: '',
        public_key: '',
        private_key: '',
        state: ''
      }
    }
  },
  categoryList: {
    type: Array,
    default: () => []
  }
})
const { token, supplierInfo, categoryList } = toRefs(props)
const editSupplierInfo = ref(supplierInfo.value)

const supplierCategoryList = categoryList.value.map(([label, value]) => ({
  value,
  label
}))

const submitForm = () => {
  $.ajax({
    url: editSupplierInfo.value.id
      ? `/settings/suppliers/${editSupplierInfo.value.id}`
      : '/settings/suppliers',
    type: editSupplierInfo.value.id ? 'PATCH' : 'POST',
    dataType: 'json',
    headers: { 'X-CSRF-Token': token.value },
    authenticity_token: true,
    data: editSupplierInfo.value,
    success: async (response) => {
      if (response.state === 0) {
        window.location.replace('/settings/suppliers')
      }
    },
    error: async (error) => {
      console.log('error', error)
      if (error.responseJSON.state === -1) {
        await mySwal.error({
          title: error.responseJSON.message.join('<br />'),
          timer: 3000
        })

        if (error.responseJSON.redirect_to) {
          window.location.replace(error.responseJSON.redirect_to)
        }
      }
    }
  })
}
</script>
<template>
  <form @submit.prevent="submitForm" class="leave-need-confirm">
    <div class="mb-3">
      <p class="flex items-baseline gap-1 py-1 text-lg font-bold">
        <span>狀態</span>
        <span class="text-sm font-light text-red-400">*</span>
      </p>
      <div class="mb-4 flex gap-3">
        <BaseRadio
          :label="'啟用'"
          :name="'state'"
          :value="'enable'"
          v-model="editSupplierInfo.state"
          required
        />
        <BaseRadio
          :label="'停用'"
          :name="'state'"
          :value="'disable'"
          v-model="editSupplierInfo.state"
          required
        />
      </div>
      <div class="mb-6 grid grid-cols-4 gap-4 md:grid-cols-2">
        <BaseTextInput
          :label="'中文名稱'"
          :name="'name'"
          v-model="editSupplierInfo.name"
          :maxlength="20"
          required
        />
        <BaseTextInput
          :label="'英文名稱'"
          :name="'english_name'"
          v-model="editSupplierInfo.english_name"
          :maxlength="20"
        />
        <BaseTextInput
          :label="'統編'"
          :name="'ubn'"
          v-model="editSupplierInfo.ubn"
          :maxlength="8"
        />
        <BaseSelect
          :label="'類型'"
          :name="'category'"
          :optionList="supplierCategoryList"
          :optionsSelected="editSupplierInfo.category"
          @select="editSupplierInfo.category = $event"
          required
        />
      </div>
      <div v-if="editSupplierInfo.id" class="grid grid-cols-2 gap-4 md:grid-cols-1">
        <div class="mb-4">
          <div class="flex items-baseline gap-1 py-1">
            <span class="text-lg font-bold">公開金鑰</span>
            <span class="text-sm font-light text-red-400">*</span>
          </div>
          <textarea
            name="public_key"
            :value="editSupplierInfo.public_key"
            @change="editSupplierInfo.public_key = $event.target.value"
            class="w-full rounded-md border"
            cols="30"
            rows="10"
            required
          ></textarea>
        </div>
        <div class="mb-4">
          <div class="flex items-baseline gap-1 py-1">
            <span class="text-lg font-bold">私密金鑰</span>
            <span class="text-sm font-light text-red-400">*</span>
          </div>
          <textarea
            name="private_key"
            :value="editSupplierInfo.private_key"
            @change="editSupplierInfo.private_key = $event.target.value"
            class="w-full rounded-md border"
            cols="30"
            rows="10"
            required
          ></textarea>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 py-3">
      <BackButton :hasForm="true" :returnPath="'/settings/suppliers'" />
      <button type="submit" class="btn btn-success text-xl text-white">
        <SendOutlined />
        送出
      </button>
    </div>
  </form>
</template>
